module.exports = "<p>\r\n  connect works!\r\n</p>\r\n"